// extracted by mini-css-extract-plugin
module.exports = {"root":"dh-dh-orderud-tidslinje-root","app":"dh-dh-orderud-tidslinje-app","logo":"dh-dh-orderud-tidslinje-logo"};